import React, { useEffect, useState } from 'react'
import Carousel from 'react-bootstrap/Carousel';
const tiposRoles = [{ "NOMBRE": "COCINA", "ABR": "PRD", "ID_CARGO": [8, 9, 102] },
{ "NOMBRE": "CAJA", "ABR": "CAJ", "ID_CARGO": [10, 101, 100] }, { "NOMBRE": "MESON", "ABR": "DSP", "ID_CARGO": [11] },
{ "NOMBRE": "LIMPIEZA", "ABR": "LIM", "ID_CARGO": [12, 103] }, { "NOMBRE": "SEGURIDAD", "ABR": "GUA", "ID_CARGO": [50, 104] }]

function ContenidoPersonalSucursal(props) {
    const { info } = props;
    const [pagina, setPagina] = useState(0);
    const [asignados, setAsignados] = useState([]);
    const [cargado, setCargado] = useState(false);
    function cambiarPagina(tipo) {
        if (tipo) {//anterior
            setPagina(pagina - 1);
        } else {
            setPagina(pagina + 1);
        }
    }
    function validarBoton(tipo) {
        if (tipo) {
            if (pagina === 0) {
                return true;
            } else {
                return false
            }
        } else {
            if (pagina === tiposRoles.length - 1) {
                return true;
            } else {
                return false
            }
        }
    }
    function obtenerRequeridos(abr, turno) {
        var requeridos = info.REQUERIDO;
        var valor = requeridos.filter((item) => item.ROL == abr && item.TURNO == turno)
        if (valor.length == 0) {
            return '0'
        } else {
            return valor[0].CANTIDAD
        }
    }
    function obtenerAsignados(abr, turno, ids) {
        var valor = asignados.filter((item) => item.ABR === abr)
        var num = valor[0].INFO.filter((item) => item.EMPRESA_TURNO === turno)
        if (num.length !== 0) {
            return num.length
        } else {
            return '0'
        }
    }
    function definirColor(valor) {
        if (valor < 0) {
            return 'bg-danger text-light'
        } else if (valor >= 0) {
            return 'bg-success text-light'
        }
    }
    function totalAsig(valor){
        var valor= asignados.filter((item)=>item.ABR===valor);
        return valor[0].INFO.length;
    }   
    useEffect(() => {
        var primero = [], segundo = [], tersero = [], cuarto = [], quinto = [];
        for (var empleado of info.ASIGNADO) {
            if ([8, 9, 102].indexOf(parseInt(empleado.EMPRESA_CARGO)) !== -1) {
                primero.push(empleado);
            } else if ([10, 101, 100].indexOf(parseInt(empleado.EMPRESA_CARGO)) !== -1) {
                segundo.push(empleado);
            } else if (11 === parseInt(empleado.EMPRESA_CARGO)) {
                tersero.push(empleado);
            } else if ([12, 103].indexOf(parseInt(empleado.EMPRESA_CARGO)) !== -1) {
                cuarto.push(empleado);
            } else if ([50, 104].indexOf(parseInt(empleado.EMPRESA_CARGO)) !== -1) {
                quinto.push(empleado);
            }
        }
        setAsignados([
            { "ABR": "PRD", "INFO": primero }, { "ABR": "CAJ", "INFO": segundo },
            { "ABR": "DSP", "INFO": tersero }, { "ABR": "LIM", "INFO": cuarto }, { "ABR": "GUA", "INFO": quinto },
        ])
    }, [])
    return (
        <>
            {asignados.length !== 0 && <div className='card-body m-0 p-0'>
                <Carousel fade={false} controls={false} indicators={false} activeIndex={pagina}>
                    {tiposRoles.map((item, index) => {
                        var reqM = obtenerRequeridos(item.ABR, 'M'), reqO = obtenerRequeridos(item.ABR, 'O'), reqN = obtenerRequeridos(item.ABR, 'N');
                        var asigM = obtenerAsignados(item.ABR, 'M', item.ID_CARGO), asigO = obtenerAsignados(item.ABR, 'O', item.ID_CARGO), asigN = obtenerAsignados(item.ABR, 'N', item.ID_CARGO);
                        var difM = asigM - reqM, difO = asigO - reqO, difN = asigN - reqN;
                        return (
                            <Carousel.Item key={index}>
                                <div className='card m-0 p-0 bg-secondary'>
                                    <div className='card-header m-0 p-0 text-center text-light fw-bold'>{item.NOMBRE+' total Asignados '+totalAsig(item.ABR)}</div>
                                    <div className='card-body m-0 p-0'>
                                        <div className='table-responsive'>
                                            <table className="table table-sm table-bordered">
                                                <thead>
                                                    <tr className='text-light fw-bold text-center'>
                                                        <th colSpan="3">MAÑANA</th>
                                                        <th colSpan="3">PARTIDO</th>
                                                        <th colSpan="3">TARDE</th>
                                                    </tr>
                                                    <tr className='text-center'>
                                                        <th colSpan="1">req</th>
                                                        <th colSpan="1">asig</th>
                                                        <th colSpan="1">diff</th>
                                                        <th colSpan="1">req</th>
                                                        <th colSpan="1">asig</th>
                                                        <th colSpan="1">diff</th>
                                                        <th colSpan="1">req</th>
                                                        <th colSpan="1">asig</th>
                                                        <th colSpan="1">diff</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr className='text-center text-light'>
                                                        <th colSpan="1">{reqM}</th>
                                                        <th colSpan="1">{asigM}</th>
                                                        <th colSpan="1" className={definirColor(difM)}>{difM}</th>
                                                        <th colSpan="1">{reqO}</th>
                                                        <th colSpan="1">{asigM}</th>
                                                        <th colSpan="1" className={definirColor(difO)}>{difO}</th>
                                                        <th colSpan="1">{reqN}</th>
                                                        <th colSpan="1">{asigN}</th>
                                                        <th colSpan="1" className={definirColor(difN)}>{difN}</th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className='container-fluid text-warning text-center'>
                                    {`Personal sin Turno = ${obtenerAsignados(item.ABR,'X',item.ABR)}`}
                                </div>
                            </Carousel.Item>
                        )
                    })}
                </Carousel>
            </div>}
            <div className='card-footer m-0 p-0 text-center'>
                <div className='row row-cols-2 g-0 px-2 m-0 p-0'>
                    <div className='col text-start m-0 p-0'>
                        <button className='btn btn-sm text-light m-0 p-0' onClick={() => cambiarPagina(true)} disabled={validarBoton(true)}>
                            <i className="bi bi-arrow-left-circle-fill fs-2" ></i>
                        </button>
                    </div>
                    <div className='col text-end m-0 p-0'>
                        <button className='btn btn-sm text-light m-0 p-0' onClick={() => cambiarPagina(false)} disabled={validarBoton(false)}>
                            <i className="bi bi-arrow-right-circle-fill fs-2"></i>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContenidoPersonalSucursal
